// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2937":"eabe11fc","5279":"6c44d60f"}[chunkId] || chunkId) + "." + {"1167":"1ba4b8cd48d8d145","1832":"f186a2b1a7558d2a","2726":"0f4f2bc50070b1f1","2937":"3f95c943130171ce","5279":"ef4ab34658fdaad0","7229":"57895636e2064bb4"}[chunkId] + ".js";
};